import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import { PRODUCT_OPERATIONS_LOADERS } from '@modules/order/stores/view/List/ListDataStore'
import { ListUIStore } from '@modules/order/stores/view/List/ListUIStore'
import classNames from 'classnames'
import get from 'lodash/get'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import QtyNumberInput from '../../components/QtyNumberInput'
import * as css from './DraftQuantity.css'
import { useProductStatus } from '@components/UI-Components/ProductCard/ProductStatusHook'
import { getNumberFromLocale } from '@utils/get-number-form-locale'

const DraftQuantity: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    const {
      uiStore: { isOrderEditable }
    } = useOrderContext()
    const viewContextVal = useViewContext()
    const isProductActive: boolean = useProductStatus(rowData)

    if (!rowData) {
      return <FieldSkeleton />
    }

    const uiStore = viewContextVal.uiStore as ListUIStore

    const index = rowData?.id
      ? uiStore.dataStore.itemIndexObjectStore.getIndexByKey(rowData.id)
      : null
    const disabled = index
      ? uiStore.dataStore.itemIndexObjectStore.isObjectsDataLoading(
          index,
          index + 1,
          PRODUCT_OPERATIONS_LOADERS.UPDATING_DRAFT_QUANTITY
        )
      : false
    return (
      <div
        className={classNames('flex justify-center w-100', css['draft-qty-container'])}
      >
        <QtyNumberInput
          id={rowData.id}
          onChange={e => {
            uiStore.updateSummaryDraftQuantity(
              rowData,
              getNumberFromLocale(e.target.value)
            )
          }}
          value={get(rowData, column.field) || 0}
          disabled={disabled || !isOrderEditable || !isProductActive}
        />
      </div>
    )
  })

export default DraftQuantity
